import React, { useState } from 'react';
import { FaStar, FaRegStar } from 'react-icons/fa';

function StarRating({ rating, onRate = null, size = '20px' }) {
    const [hovered, setHovered] = useState(0);
    const interactive = onRate !== null;

    return (
        <div style={{ display: 'flex', gap: '2px' }}>
            {[1, 2, 3, 4, 5].map((star) => {
                const filled = interactive
                    ? star <= (hovered || rating)
                    : star <= rating;
                const StarIcon = filled ? FaStar : FaRegStar;
                return (
                    <StarIcon
                        key={star}
                        style={{
                            fontSize: size,
                            color: '#d4a574',
                            cursor: interactive ? 'pointer' : 'default',
                            transition: 'transform 0.1s ease'
                        }}
                        onClick={() => interactive && onRate(star)}
                        onMouseEnter={() => interactive && setHovered(star)}
                        onMouseLeave={() => interactive && setHovered(0)}
                    />
                );
            })}
        </div>
    );
}

export default StarRating;
